// src/modules/Courier/pages/CourierModal/pages/ScannersPage.jsx
import React, { useState, useEffect, useMemo, useRef} from 'react';
import styles from '../styles/ScannersPage.module.css';
import { useModalPage } from '../CourierModal';
import { useRouteStore } from '../../Route/useRouteStore';
import api from '../../../../services/api';
import ScannerV1 from './Scanners/ScannerV1';
import ScannerV2 from './Scanners/ScannerV2';
import ScannerTSD from './Scanners/ScannerTSD';
import ScannerManual from './Scanners/ScannerManual';

import scanBeepFile from './Scanners/beep.mp3';        // звук сканирования
const scanBeepAudio = new Audio(scanBeepFile);

// Режимы сканирования
const SCANNER_MODES = [
  // { key: 'cameraV1', label: 'Камера V1', Component: ScannerV1 },
  { key: 'cameraV2', label: 'Камера', Component: ScannerV2 },
  { key: 'tsd',      label: 'TSD-сканер', Component: ScannerTSD },
  { key: 'manual',   label: 'Ручной ввод', Component: ScannerManual },
];

export default function ScannersPage() {

  const [scanSoundOn] = useState(() => {
  const v = localStorage.getItem('scanner.scanSoundOn');
    return v === null ? true : JSON.parse(v);
  });

    const [scanVibrationOn] = useState(() => {
    const v = localStorage.getItem('scanner.scanVibrationOn');
    return v === null ? false : JSON.parse(v);
  });

  // Сохраняем настройку при изменении (если в будущем захотите переключать в UI)
  useEffect(() => {
    localStorage.setItem('scanner.scanSoundOn', JSON.stringify(scanSoundOn));
  }, [scanSoundOn]);

  useEffect(() => {
    localStorage.setItem('scanner.scanVibrationOn', JSON.stringify(scanVibrationOn));
  }, [scanVibrationOn]);


  const [serverMessage, setServerMessage] = useState(null);            // текст
  const [serverMessageType, setServerMessageType] = useState('success'); // 'success' или 'error

  // 1️⃣ Модалка и стор
  const { goTo, close } = useModalPage();
  const receipt        = useRouteStore(s => s.selectedReceipt);
  const updateReceipt  = useRouteStore(s => s.updateReceipt);
  const setIsScanning = useRouteStore(s => s.setIsScanning);
  const pendingScans = useRef(new Map());
  // ТИПЫ, которые скипаем
  const skipTypes = ["ПоСчету","Кредит","Взаимозачет","Дилер","БезОплаты"];

  // 2️⃣ Режим сканера
  const [scanMode, setScanMode] = useState(() => {
    const saved = localStorage.getItem('scanMode');
    return SCANNER_MODES.some(m => m.key === saved)
      ? saved
      : SCANNER_MODES[0].key;
  });
  const ActiveScanner = useMemo(
    () => SCANNER_MODES.find(m => m.key === scanMode)?.Component || ScannerV1,
    [scanMode]
  );

  useEffect(() => {
  if (!serverMessage) return;          // ничего не делаем, если нет сообщения
  const timer = setTimeout(() => {
    setServerMessage(null);
  }, 3000);                            // 3000 мс = 3 секунды

  return () => clearTimeout(timer);    // сброс таймера при смене сообщения или анмаунте
}, [serverMessage]);

  // 3️⃣ Сохраняем выбор режима
  useEffect(() => {
    localStorage.setItem('scanMode', scanMode);
  }, [scanMode]);

  useEffect(() => {
    setIsScanning(true);
    return () => {
      setIsScanning(false);
    };
  }, [setIsScanning]);

   const handlePhotoCaptured = async (blob) => {
   const filename = receipt?.receipt_number
     ? `${receipt.id}-${receipt.receipt_number}.png`
     : "photo.png";
   const formData = new FormData();
   formData.append("file", blob, filename);
   if (receipt?.receipt_number) {
     formData.append("receipt_number", receipt.receipt_number);
   }
   try {
     await api.post("/upload/", formData);
     // здесь можно обновить UI, например:
     console.log(`Файл "${filename}" загружен`);
   } catch (error) {
     console.error(`Ошибка загрузки "${filename}":`, error);
   }
 };


  // 4️⃣ Логика прогресса
 const progress = useMemo(() => {

  if (!receipt) return { total: 0, scanned: 0 };
  // only count products that actually need scanning
  const marked = receipt.products.filter(p => p.is_marked);
  let total = 0, scanned = 0;
  marked.forEach(p => {
    total   += p.actual_quantity;
    scanned += p.marks?.length || 0;
  });
   return { total, scanned };
 }, [receipt]);

  const allScanned = progress.scanned >= progress.total;

  // 5️⃣ Обработчик сканирования
  const onMarkScanned = async decodedText => {
    const now = Date.now();
    const last = pendingScans.current.get(decodedText) || 0;
    if (now - last < 2000) return;
    pendingScans.current.set(decodedText, now);
    try {
      const { receipt: updatedReceipt, message } = await api.post(
        `/receipts/${receipt.id}/scan`,
        { marks: [decodedText] }
      );
      updateReceipt(updatedReceipt);
      if (JSON.parse(localStorage.getItem('scanner.scanSoundOn') ?? 'true')) {
        scanBeepAudio.currentTime = 0;
        scanBeepAudio.play();
      }
      if (JSON.parse(localStorage.getItem('scanner.scanVibrationOn') ?? 'false') && navigator.vibrate) {
        navigator.vibrate(200);
      }
      // показываем сообщение от сервера
     setServerMessage(message || 'Метка успешно отправлена');
     setServerMessageType('success');
    } catch (e) {
      console.error(e.response?.data?.error || e.message);
     setServerMessage(e.response?.data?.error || 'Ошибка при отправке метки');
     setServerMessageType('error');
    }finally {
    // разрешаем повторный скан этой же метки через 2 сек
    setTimeout(() => pendingScans.current.delete(decodedText), 2000);
  }
  };

  // 6️⃣ Переход на "check" только при полном сканировании
   useEffect(() => {
   if (!receipt || progress.total === 0 || !allScanned) return;

   if (skipTypes.includes(receipt.payment_type)) {
     // сразу закрываем квитанцию
     api.patch(`/receipts/${receipt.id}/status`, { status: 'Закрыта' })
       .then(res => {
         // защищённо дергаем ответ
         const updated = res?.receipt ?? res;
         updateReceipt(updated);
         close(null);            // закрываем модалку
       })
       .catch(err => {
         console.error('Не удалось закрыть квитанцию:', err);
         // можете показать ошибку UI, если нужно
       });
   } else {
     // иначе — как раньше, переходим на выдачу чека
     goTo('issueCheck');
   }
 }, [allScanned, goTo, receipt, progress.total, updateReceipt, close]);

  // 7️⃣ Рендер
  if (!receipt) {
    return <p className={styles.messageError}>Квитанция не загружена</p>;
  }

  const isMultiColumn = receipt.products.length > 2;

// Внутри ScannersPage в return заменяем старый фрагмент прогресс-бара на этот:
return (
  <div className={styles.container}>

    <div className={styles.tabs}>
      {SCANNER_MODES.map(({ key, label }) => (
        <button
          key={key}
          className={`${styles.tab} ${scanMode === key ? styles.active : ''}`}
          onClick={() => setScanMode(key)}
        >
          {label}
        </button>
      ))}
    </div>
    {serverMessage && (
     <div
       className={
         serverMessageType === 'success'
         ? styles.bannerSuccess
         : styles.bannerError
       }
     >
       {serverMessage}
     </div>
   )}
    <div className={styles.body}>
          <div
      className={`${styles.progressContainer} ${
        isMultiColumn ? styles.twoColumns : ''
      }`}
    >
      {receipt.products.map(p => {
        const count   = p.marks?.length || 0;
        const percent = Math.round((count / p.actual_quantity) * 100);
        return (
          <div key={p.id} className={styles.barWrapper}>
            <div
              className={styles.fill}
              style={{ width: `${percent}%` }}
            />
            <div className={styles.content}>
              <span className={styles.text}>
                {p.product_name}{' '}
                {p.is_marked ? `${count}/${p.actual_quantity}` : '(Без маркировки)'}
              </span>
            </div>
          </div>
        );
      })}
    </div>

      <div className={styles.scannerWrapper}>
               <ActiveScanner
         onMarkScanned={onMarkScanned}
         onPhotoCaptured={handlePhotoCaptured}
       />
      </div>
    </div>
  </div>
);


}